import React, { useContext, useState, useEffect, useRef } from "react";
// import TextContext from "../../../context/TextContext"
//file updated
import MyContext from "../../../context/MyContext";
import axios from "axios";
import AuthContext from "../../../context/userAuth.context";
import swal from "sweetalert";
import TickerContext from "../../../context/ticker";
import html2canvas from "html2canvas";
import ProjectContext from "../../../context/ProjectContext";
import Lottie from "lottie-web";
import Lottie2 from "react-lottie";
import loader from "../../../assets/Loader/AssetLoader.json";
export const TextWrapper = (props) => {
  const {
    timelineZoomVal,
    setLayersData,
    LayersData,
    calculateTimeByWidth,
    clone,
    setRedoLayer,
    UndoLayer,
    setUndoLayer,
    Tl_TotalTime,
    calculateWidthByDuration,
    ChangeCount,
    setChangeCount,
    TextCategories,
    setTextCategories,
    EditorZoom,
    seteditableObject,
  } = useContext(MyContext);
  const { Role, authenticationData } = useContext(AuthContext);

  const { slides, setslides } = useContext(ProjectContext);

  function getRandomArbitrary(min, max) {
    return parseInt(Math.random() * (max - min) + min);
  }
  const { TickerPosition } = useContext(TickerContext);

  const [ShowCategories, setShowCategories] = useState(false);
  const [SelectedCategoryId, setSelectedCategoryId] = useState(0);
  const [TextEffects, setTextEffects] = useState([]);
  const [MyLoader, setMyLoader] = useState(true);

  let authData = JSON.parse(
    localStorage.getItem("animation_studio_2.0_access_token")
  );

  // useEffect(() => {
  //   axios
  //     .get(
  //       authenticationData.ApiBaseURL + "/api/Stylishtext/GetTextCategories",
  //       {
  //         headers: {
  //           "Content-Type": `multipart/form-data`,
  //           "Access-Control-Allow-Origin": "*",
  //           Authorization: "Bearer " + authData.access_token,
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       let arr = [];
  //       for (let i = 0; i < response.data.categories.length; i++) {
  //         let obj = {
  //           id: 0,
  //           categoryName: "",
  //           defaultImgPath: "",
  //           data: [],
  //         };
  //         obj.id = response.data.categories[i].id;
  //         obj.categoryName = response.data.categories[i].categoryName;
  //         obj.defaultImgPath = response.data.categories[i].categoryImagePath;
  //         obj.data = [];
  //         arr.push(obj);
  //       }
  //       setTextCategories(arr);
  //     })
  //     .catch((excetion) => {
  //       console.log(excetion);
  //     });
  // }, []);

  useEffect(() => {
    axios
      .get(
        authenticationData.ApiBaseURL + `/api/Stylishtext/GetDefaultTexts?id=5`,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {
        setTextEffects(response.data.texts);
        setMyLoader(false);
      })
      .catch((error) => {
        //console.log(error);
      });
  }, []);

  const UploadDefaultText = async () => {
    if (SelectedCategoryId == 0) {
      swal("Error", "First select a category", "error");
      return;
    }
    if (LayersData.length == 0) {
      swal("Error", "First add some elements", "error");
      return;
    }
    var maxHeight = 0,
      maxWidth = 0;
    var minLeft = LayersData[0].x,
      minTop = LayersData[0].y;
    for (let i = 0; i < LayersData.length; i++) {
      if (LayersData[i].width > maxWidth) maxWidth = LayersData[i].width;
      if (LayersData[i].height > maxHeight) maxHeight = LayersData[i].height;

      if (minLeft > LayersData[i].x) minLeft = LayersData[i].x;
      if (minTop > LayersData[0].y) minTop = LayersData[0].y;
    }
    let canvas = document.createElement("canvas");
    canvas.height = maxHeight;
    canvas.width = maxWidth;
    const getContext = () => canvas.getContext("2d");
    const ctx = getContext();

    let testDiv = document.createElement("div");
    testDiv.style.width = maxWidth + "px";
    testDiv.style.height = maxHeight + "px";
    testDiv.style.position = "relative";

    const print = (options) => {
      return new Promise(async (resolve, reject) => {
        const myOptions = Object.assign({}, options);
        let flip = "";
        if (myOptions.flip == "scaleX(-1)") {
          flip = " scaleX(-1)";
        }
        let left = myOptions.x - minLeft;
        let top = myOptions.y - minTop;
        if (options.type === "image") {
          let img = await loadImage(options.ImageSrc); //document.getElementsByClassName(options.Name)[0]
          // ctx.drawImage(img, left, top, myOptions.width, myOptions.height);
          img.style.left = left + "px";
          img.style.top = top + "px";
          img.style.width = (myOptions.width * EditorZoom) / 100 + "px";
          img.style.height = (myOptions.height * EditorZoom) / 100 + "px";
          img.style.position = "absolute";
          img.style.transform = `rotate(${myOptions.rotateAngle}deg)${flip}`;

          testDiv.appendChild(img);
        } else if (options.type === "Shape") {
          let Shape = await loadImage(options.ShapePath); //document.getElementsByClassName(options.Name)[0]
          //ctx.drawImage(Shape, left, top, options.width, options.height);

          let _canvas = document.createElement("canvas");
          _canvas.width = Shape.width;
          _canvas.height = Shape.height;
          let _ctx = _canvas.getContext("2d");
          _ctx.drawImage(Shape, 0, 0);

          _canvas.style.left = left + "px";
          _canvas.style.top = top + "px";
          _canvas.style.width = (myOptions.width * EditorZoom) / 100 + "px";
          _canvas.style.height = (myOptions.height * EditorZoom) / 100 + "px";
          _canvas.style.position = "absolute";
          _canvas.style.transform = `rotate(${myOptions.rotateAngle}deg)${flip}`;

          testDiv.appendChild(_canvas);
        } else if (options.type === "text") {
          // ctx.font = `${options.fontWeight} ${options.fontSize + "px"} Roboto`;
          // ctx.fillStyle = options.textColor;
          // ctx.textAlign = options.Align;
          // ctx.fillText(options.text, left + (options.width / 2), top + (options.fontSize), options.width);

          let TopParent = document.createElement("div");
          TopParent.style.left = left + "px";
          TopParent.style.top = top + "px";
          TopParent.style.width = (myOptions.width * EditorZoom) / 100 + "px";
          TopParent.style.height = (myOptions.height * EditorZoom) / 100 + "px";
          TopParent.style.position = "absolute";
          TopParent.style.transform = `rotate(${myOptions.rotateAngle}deg)`;

          let spanParant = document.createElement("div");
          spanParant.style.textAlign = myOptions.Align;

          let span = document.createElement("span");
          span.style.textDecoration = myOptions.textDec;
          span.style.fontStyle = myOptions.Fontstyle;
          span.style.fontWeight = myOptions.fontWeight;
          span.style.opacity = myOptions.opacity;
          span.style.color = myOptions.textColor;
          span.style.fontFamily = myOptions.googleFontSetting.fontFamily;
          span.style.fontSize =
            Math.round((myOptions.fontSize * EditorZoom) / 100) + "px";
          span.style.overflowWrap = "break-word";
          span.style.lineHeight = "normal";
          span.innerHTML = myOptions.text;
          spanParant.appendChild(span);
          TopParent.appendChild(spanParant);

          testDiv.appendChild(TopParent);
        }
        resolve();
      });
    };
    for (let i = 0; i < LayersData.length; i++) {
      await print(LayersData[i]);
    }
    document.body.appendChild(testDiv);
    html2canvas(testDiv).then((can) => {
      const imgData = can.toDataURL("image/png");
      let myImg = new Image();
      myImg.onload = function () {
        let resizedCanvas = document.createElement("canvas");
        let resizedData = calculateAspectRatioFit(
          myImg.width,
          myImg.height,
          300,
          300
        );
        resizedCanvas.width = resizedData.width;
        resizedCanvas.height = resizedData.height;
        let resizedCtx = resizedCanvas.getContext("2d");
        resizedCtx.drawImage(
          myImg,
          0,
          0,
          resizedCanvas.width,
          resizedCanvas.height
        );
        testDiv.remove();

        let obj = {
          PreviewImgPath: resizedCanvas.toDataURL("image/png"),
          LayerData: JSON.stringify(LayersData),
          categoryId: SelectedCategoryId,
        };
        axios
          .post(
            authenticationData.ApiBaseURL + "/api/Stylishtext/UploadText",
            obj,
            {
              headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                Authorization: "Bearer " + authData.access_token,
              },
            }
          )
          .then((response) => {
            if (response.data) {
              swal("Excellent", "Text Has Been Uploaded", "success");
            } else {
              swal(
                "Failed",
                "Unable to Upload Image. Please Try Again",
                "error"
              );
            }
          })
          .catch((excetion) => {
            //console.log(excetion);
            swal("Failed", "Unable to Upload Image. Please Try Again", "error");
          });
        setShowCategories(false);
      };
      myImg.src = imgData;
    });
  };

  function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
    var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
    return { width: srcWidth * ratio, height: srcHeight * ratio };
  }

  function loadImage(path) {
    return new Promise((resolve, reject) => {
      let img = new Image();
      img.onload = function () {
        resolve(img);
      };
      img.src = path;
    });
  }

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  const tempText = (TextString, fontSize) => {
    let percentage = 497 / 1024;
    fontSize = parseInt(fontSize * percentage);

    let span = document.createElement("span");
    span.id = "tempText";
    span.style.fontWeight = TextString === "Headline Title" ? "bold" : "normal";
    span.style.color = "#333333";
    span.style.fontFamily = "Circular";
    span.style.fontSize = fontSize + "px";
    span.style.overflowWrap = "break-word";
    span.style.lineHeight = "normal";
    span.style.position = "absolute";
    span.style.left = "0px";
    span.style.top = "0px";

    span.innerHTML = TextString;
    document.getElementsByClassName("EditorParent")[0].appendChild(span);

    let textObj = {
      width:
        TextString === "Headline Title"
          ? document.getElementById("tempText").clientWidth + 10
          : document.getElementById("tempText").clientWidth + 25,
      height: document.getElementById("tempText").clientHeight,
      Lineheight: document.getElementById("tempText").clientHeight + "px",
    };

    document.getElementById("tempText").remove();

    return textObj;
  };
  const onButtonClick = (fontSize, height, TextString) => {
    const textObj = tempText(TextString, fontSize);

    var canvasHeight =
      document.getElementsByClassName("EditorTrackInner")[0].offsetHeight;
    var CanvasWidth =
      document.getElementsByClassName("EditorTrackInner")[0].offsetWidth;

    let percentage = 497 / 1024;
    fontSize = parseInt(fontSize * percentage);
    height = height * percentage;
    let _width = CanvasWidth * percentage;

    var top = getRandomArbitrary(0, canvasHeight - height);
    var left = getRandomArbitrary(0, CanvasWidth - _width);

    let stack = [...UndoLayer];
    let PrevArray = clone(LayersData);

    if (stack.length < 10) {
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    } else {
      stack.shift();
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    }

    var topIndex = 0;
    if (LayersData.length > 0) {
      topIndex = LayersData[LayersData.length - 1].layerIndex;
      topIndex = topIndex + 1;
    }

    var typelength = 1;
    var checkKey = 0;
    for (var i = 0; i < LayersData.length; i++) {
      LayersData[i].toolbar = false;
      if (LayersData[i].Editable === true) {
        LayersData[i].Editable = false;
        LayersData[i].showDiv = false;
      }
      if (LayersData[i].type === "text") {
        typelength = typelength + 1;
      }
      if (LayersData[i].key >= checkKey) {
        checkKey = LayersData[i].key;
      }
    }

    let currentTime = calculateTimeByWidth(TickerPosition);
    let totalTime = calculateTimeByWidth(Tl_TotalTime.width - TickerPosition);

    let newEntryLayerData = {
      Added: true,
      key: checkKey + 1,
      type: "text",
      spanHeight: "",
      spanWidth: "",
      scale: 1,
      bgColor: "#323232",
      Name: `text-${typelength}`,
      TextId: makeid(6),
      AnimationId: makeid(6),
      canvas: null,
      userFile: "xyz",
      layerIndex: topIndex,
      index: null,
      TimelineZoom: timelineZoomVal,
      duration: totalTime,
      startTime: currentTime,
      endTime: calculateTimeByWidth(Tl_TotalTime.width),
      visible: true,
      OutEffect: "none",
      InEffect: "none",
      typeIcon: "text_fields",
      startTransitionWidth: 0,
      startTransitionLeft: 0,
      endTransitionWidth: 0,
      endTransitionLeft: 0,
      originalX: null,
      transform: "translate(0px, 0px)",
      text: TextString,
      x: left,
      y: top,
      edit: "false",
      fontSize: fontSize,
      Align: "center",
      fontWeight: TextString == "Headline Title" ? "bold" : "normal",
      Fontstyle: "calibri",
      textDec: "none",
      opacity: 1,
      originalOpacity: 1,
      width: textObj.width,
      height: textObj.height,
      toolbar: true,
      FurtherSetting: false,
      EditorZoom: EditorZoom,
      //LineHeight: textObj.Lineheight,
      LineHeight: 1.1,
      LetterSpacing: 0,
      textColor: "#333333",
      lock: false,
      layerlock: false,
      opc: 1, //its use for the eye on the timeline wrapper for lock
      hidden: false,
      Editable: true,
      startPositionOnTimeline: TickerPosition,
      rotateAngle: 0,
      googleFontSetting: {
        fontName: "Circular",
        fontFamily: "Circular",
        googleFontUrl: "../fonts/Circular/CircularStd-Medium.otf",
      },
      InMultiDrag: false,
      showDiv: true,
    };

    //1px is equal to 13.28ms and 15.06px is 200ms so 1s equals to 75.30px so now calculate width based on duration
    newEntryLayerData.widthOnTimeline = calculateWidthByDuration(
      newEntryLayerData.duration
    );
    newEntryLayerData.endTransitionLeft =
      newEntryLayerData.widthOnTimeline - newEntryLayerData.endTransitionWidth;
    setLayersData(LayersData.concat(newEntryLayerData));

    setChangeCount(ChangeCount + 1);

    //ShowPanelLeft
    seteditableObject({ showPanel: true, editableItem: newEntryLayerData });
  };

  return (
    <div id="textWrapper" className="innerWrapperPanel">
      <div className="templatesWrapper">
        <div className="divLabel mb-3">Text</div>

        <div
          className="style-1"
          style={{ height: "calc(100% - 66px)", overflowY: "scroll" }}
        >
          {Role.toLowerCase() == "admin" && (
            <>
              <div className="image_uploader">
                <div
                  onClick={() => {
                    setShowCategories(true);
                  }}
                  className="image_uploader_inner"
                >
                  <div className="image_uploader_icon_container">
                    <span
                      style={{
                        fontSize: "18px",
                        fontWeight: "600",
                      }}
                      className="material-icons"
                    >
                      upload
                    </span>
                  </div>

                  <div className="uploadText">
                    <div>Upload Text</div>
                  </div>
                </div>
              </div>
              {ShowCategories && (
                <TextPopup
                  TextCategories={TextCategories}
                  SelectedCategoryId={SelectedCategoryId}
                  setSelectedCategoryId={setSelectedCategoryId}
                  setShowCategories={setShowCategories}
                  ShowCategories={ShowCategories}
                  UploadDefaultText={UploadDefaultText}
                />
              )}
            </>
          )}

          <div
            onClick={() => onButtonClick(60, 60, "Headline Title")}
            className="text_uploader_inner"
          >
            <div className="Image_uploader_text" style={{ fontSize: "24px" }}>
              <div>Headline Title</div>
            </div>
          </div>

          <div
            onClick={() => onButtonClick(60, 60, "Subheading Title")}
            className="text_uploader_inner"
          >
            <div className="Image_uploader_text" style={{ fontSize: "20px" }}>
              <div>Subheading Text</div>
            </div>
          </div>
          <div style={{ marginTop: "10px" }}>
            {TextEffects.length > 0 ? (
              TextEffects.map((lmc, index) => {
                return (
                  <>
                    <BackGroundChild lmc={lmc} key={index.toString()} />
                  </>
                );
              })
            ) : (
              <Lottie2
                options={{ loop: true, autoplay: true, animationData: loader }}
                height={200}
                width={200}
                isStopped={false}
                isPaused={false}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default TextWrapper;

const TextPopup = (props) => {
  return (
    <div className="TextCategoryDropDown" style={{ animation: "fadeIn 0.5s" }}>
      <div
        x-placement="top-start"
        aria-labelledby="dropdown-basic"
        data-popper-placement="top-start"
        className=" shadow-sm border-0 show"
      >
        <div className="custom-dropdownBody">
          {props.TextCategories.map((value, index) => {
            return (
              <span
                className={
                  "custom-dropdown-elem " +
                  (value.id == props.SelectedCategoryId ? "active" : "")
                }
                onClick={() => {
                  props.setSelectedCategoryId(value.id);
                }}
              >
                {value.categoryName}
              </span>
            );
          })}
        </div>
        <div className="text-center">
          <button
            className="btn btn-primary m-1"
            onClick={() => {
              props.UploadDefaultText();
            }}
          >
            save
          </button>
          <button
            className="btn btn-default m-1"
            onClick={() => {
              props.setShowCategories(false);
            }}
          >
            cancel
          </button>
        </div>
      </div>
    </div>
  );
};

const BackGroundChild = ({ lmc }) => {
  const { authenticationData } = useContext(AuthContext);
  const [ShowItems, setShowItems] = useState(false);

  return (
    <>
      <div className="CharacterShow2">
        <div className="character_container" style={{ background: "#ffffff" }}>
          <div className="character_container_insider">
            {<BackgroundWrap id={lmc.id} lmc={lmc} />}
          </div>
        </div>
      </div>
    </>
  );
};

const BackgroundWrap = ({ id, lmc }) => {
  const { authenticationData } = useContext(AuthContext);
  const { TextCategories, setTextCategories } = useContext(MyContext);
  const [ShowPreviewImg, setShowPreviewImg] = useState(true);

  // useEffect(() => {
  //   if (lmc.data.length == 0) {
  //     let authData = JSON.parse(
  //       localStorage.getItem("animation_studio_2.0_access_token")
  //     );
  //     axios
  //       .get(
  //         authenticationData.ApiBaseURL +
  //           `/api/Stylishtext/GetDefaultTexts?id=${lmc.id}`,
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //             "Access-Control-Allow-Origin": "*",
  //             Authorization: "Bearer " + authData.access_token,
  //           },
  //         }
  //       )
  //       .then((response) => {
  //         if (response.data.status) {
  //           let arr = Array.from(TextCategories);
  //           for (let i = 0; i < arr.length; i++) {
  //             if (arr[i].id == id) {
  //               arr[i].data = response.data.texts;
  //             }
  //           }
  //           // debugger
  //           setTextCategories(arr);
  //         }
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //       });
  //   }
  // }, []);

  return (
    <>
      <div className="Character_folder_items">
        <div style={{ width: "100%", height: "auto" }}>
          <div className="Char_assetsList">
            {
              <BackPics
                obj={lmc}
                key={lmc.id}
                ShowPreviewImg={ShowPreviewImg}
                setShowPreviewImg={setShowPreviewImg}
              />
            }
          </div>
        </div>
      </div>
    </>
  );
};

const BackPics = ({ index, obj, ShowPreviewImg, setShowPreviewImg }) => {
  const { authenticationData, Role } = useContext(AuthContext);
  const {
    setLayersData,
    LayersData,
    TextCategories,
    setTextCategories,
    setBackgrounds,
    timelineZoomVal,
    calculateTimeByWidth,
    clone,
    setRedoLayer,
    UndoLayer,
    setUndoLayer,
    calculateWidthByDuration,
    Tl_TotalTime,
    ChangeCount,
    seteditableObject,
    setChangeCount,
    EditorZoom,
  } = useContext(MyContext);
  const { Goto, setGoto, TickerPosition } = useContext(TickerContext);
  const BackgroundAnimation = useRef(null);
  const [delayHandler, setDelayHandler] = useState(null);
  const [state, setstate] = useState(false);
  const [PropData, setPropData] = useState(null);

  const setData = () => {
    let data = JSON.parse(obj.layerData);
    let tempLayerData = [];
    let highestKey = 0;
    for (let i of LayersData) {
      if (i.key >= highestKey) {
        highestKey = i.key;
      }
      tempLayerData.push(i);
    }

    for (let i of data) {
      highestKey = highestKey + 1;
      i.key = highestKey;
      if (i.InEffect == "none") {
        i.startTransitionWidth = 0;
      }
      if (i.OutEffect == "none") {
        i.endTransitionWidth = 0;
      }
      tempLayerData.push(i);
    }
    setLayersData(tempLayerData);
    // }
  };

  const playAnim = () => {
    setDelayHandler(
      setTimeout(() => {
        let ctx = null;
        setShowPreviewImg(false);
        if (obj.isAnimated) {
          if (
            BackgroundAnimation.current == null ||
            BackgroundAnimation.current == undefined
          )
            return;
        }

        //console.log(authenticationData.ApiBaseURL + "/" + obj.previewImgPath);
        Lottie.destroy(obj.json);

        // ctx = BackgroundAnimation.current.getContext("2d");
        const get = Lottie.loadAnimation({
          container: BackgroundAnimation.current,
          name: obj.json,
          renderer: "svg",
          loop: true,
          autoplay: true,
          path: authenticationData.ApiBaseURL + "/" + obj.json,
          rendererSettings: {
            preserveAspectRatio: "xMidYMin slice",
            viewBoxOnly: true,
            progressiveLoad: true,
          },
        });

        setPropData(get);
        setstate(true);
      }, 500)
    );
  };

  const AddProp = () => {
    var canvasHeight =
      document.getElementsByClassName("EditorTrackInner")[0].offsetHeight;
    var CanvasWidth =
      document.getElementsByClassName("EditorTrackInner")[0].offsetWidth;

    let percentage = 997 / 1024;
    let fontSize = 100;
    let height = 100;

    fontSize = parseInt(fontSize * percentage);
    let _width = CanvasWidth * percentage;
    height = height * percentage;

    var top = getRandomArbitrary(0, canvasHeight - height);
    var left = getRandomArbitrary(0, CanvasWidth - _width);
    let stack = [...UndoLayer];
    let PrevArray = clone(LayersData);

    if (stack.length < 10) {
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    } else {
      stack.shift();
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    }
    var topIndex = 0;
    if (LayersData.length > 0) {
      topIndex = LayersData[LayersData.length - 1].layerIndex;
      topIndex = topIndex + 1;
    }
    var typelength = 1;
    var checkKey = 0;
    for (var i = 0; i < LayersData.length; i++) {
      if (LayersData[i].Editable === true) {
        LayersData[i].Editable = false;
        LayersData[i].showDiv = false;
      }
      LayersData[i].toolbar = false;
      if (LayersData[i].type === "AnimatedText") {
        typelength = typelength + 1;
      }
      if (LayersData[i].key >= checkKey) {
        checkKey = LayersData[i].key;
      }
    }

    let currentTime = calculateTimeByWidth(TickerPosition);
    let totalTime = calculateTimeByWidth(Tl_TotalTime.width - TickerPosition);
    let newEntryLayerData = {
      Added: true,
      NewAdded: true,
      AddedInSVG: false,
      AnimationId: makeid(7),
      key: checkKey + 1,
      type: "AnimatedText",
      bgColor: "#97b0ff",
      Name: `AnimatedText-${typelength}`,
      canvas: null,
      EditorZoom: EditorZoom,
      userFile: "xyz",
      layerIndex: topIndex,
      index: null,
      TimelineZoom: timelineZoomVal,
      duration: totalTime,
      startTime: currentTime,
      endTime: calculateTimeByWidth(Tl_TotalTime.width),
      visible: true,
      OutEffect: "none",
      InEffect: "none",
      typeIcon: "person",
      Character_poses: obj.json,
      ImageSrc: obj.previewImgPath,
      character_FilePath: obj.json, //with out .json
      startTransitionWidth: 0,
      startTransitionLeft: 0,
      endTransitionWidth: 0,
      endTransitionLeft: 0,
      x: left,
      y: top,
      opacity: 1,
      originalOpacity: 1,
      width: 250,
      height: height,
      height2: height,
      toolbar: true,
      FurtherSetting: false,
      lock: false,
      layerlock: false,
      opc: 1,
      hidden: false,
      Editable: true,
      CharacterStop: true,
      CharacterPause: false,
      CharacterPlayed: false,
      startPositionOnTimeline: TickerPosition,
      player: false,
      Animate: false,
      flip: "scaleX(1)",
      rotateAngle: 0,
      AzData: null,
      startAtoZ: false,
      InMultiDrag: false,
      ImageFrame: 0,
      LoadLottie: true,
      showDiv: true,
      googleFontSetting: {
        fontName: "Roboto",
        fontFamily: "'Roboto', sans-serif",
        googleFontUrl:
          "https://fonts.googleapis.com/css2?family=Roboto:wght@100&display=swap",
      },
      JSONValue: (async () => {
        const resp = await fetch(
          authenticationData.ApiBaseURL + "/" + obj.json
        );
        const jsonData = await resp.json();
        newEntryLayerData.width = jsonData.w;
        newEntryLayerData.Added = true;
        newEntryLayerData.height = jsonData.h;

        let _find = false;

        jsonData.assets.map((value) =>
          value.layers.map((layer_value) => {
            if (layer_value.t) {
              _find = true;
            }
          })
        );

        if (jsonData.assets.length > 0 && _find) {
          jsonData.assets.map((value) => {
            if (!value.layers[0]?.nm.toLowerCase().includes("text")) {
              value.layers[0].nm = "text " + value.layers[0].nm;
            }
          });
          jsonData.fromAssets = true;
        } else {
          jsonData?.layers?.map((value) => {
            if (value.t) {
              if (!value.nm.toLowerCase().includes("text")) {
                value.nm = "text " + value.nm;
              }
            }
          });
          jsonData.fromAssets = false;
        }

        newEntryLayerData.JSONValue = jsonData;
        //newEntryLayerData.OriginalJSONValue = newEntryLayerData.JSONValue;
        newEntryLayerData.widthOnTimeline = calculateWidthByDuration(
          newEntryLayerData.duration
        );
        newEntryLayerData.endTransitionLeft =
          newEntryLayerData.widthOnTimeline -
          newEntryLayerData.endTransitionWidth;

        setLayersData(LayersData.concat(newEntryLayerData));

        setChangeCount(ChangeCount + 1);
        //ShowPanelLeft
        seteditableObject({ showPanel: true, editableItem: newEntryLayerData });
        return jsonData;
      })(),
    };
  };

  const stopAnim = () => {
    //showImgPanel=true;
    setstate(false);
    clearTimeout(delayHandler);
    if (PropData != null) {
      if (Lottie) Lottie.destroy(obj.json);
      setPropData(null);
    }
    setShowPreviewImg(true);
  };

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  function getRandomArbitrary(min, max) {
    return parseInt(Math.random() * (max - min) + min);
  }

  const deleteText = () => {
    let id = obj.id;
    let previewImgPath = obj.previewImgPath;
    let authData = JSON.parse(
      localStorage.getItem("animation_studio_2.0_access_token")
    );
    axios
      .delete(
        authenticationData.ApiBaseURL +
          `/api/Stylishtext/DeleteDefaultText?id=${id}&previewImgPath=${previewImgPath}`,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          let array = Array.from(TextCategories);
          let data = [];
          for (let i = 0; i < array.length; i++) {
            if (array[i].id == obj.categoryId) {
              data = array[i].data.filter((item) => item.id !== id);
              array[i].data = data;
            }
          }
          //var changeArray = array.filter(item => item.id !== id);
          setTextCategories(array);
        }
      })
      .catch((error) => {
        //console.log(error);
        swal("Error", "Text not deleted", "error");
      });
  };

  return obj.isAnimated == true ? (
    <div
      style={{ width: "100%" }}
      className={"AnimatedBackgorund_items_start "}
      onMouseEnter={playAnim}
      onClick={AddProp}
      onMouseLeave={stopAnim}
    >
      {ShowPreviewImg == true ? (
        <img
          src={authenticationData.ApiBaseURL + "/" + obj.previewImgPath}
          style={{
            width: "100%",
            height: "100%",
          }}
        />
      ) : (
        <div
          ref={BackgroundAnimation}
          style={{
            width: "100%",
            height: "100%",
          }}
        ></div>
      )}
    </div>
  ) : (
    <div
      key={index}
      className="Asset_items slide-loader-wrapper"
      style={{ flexBasis: "46.8%", position: "relative", height: "100%" }}
    >
      <img
        src={authenticationData.ApiBaseURL + "/" + obj.previewImgPath}
        style={{ width: "100%", borderRadius: "10px" }}
        onClick={setData}
      />
      {Role == "admin" && (
        <div
          style={{
            width: "29px",
            height: "29px",
            background: "#a7a5a5",
            position: "absolute",
            top: "10px",
            left: "10px",
            borderRadius: "10px",
          }}
          onClick={deleteText}
        >
          <span
            class="material-icons"
            style={{
              padding: "2px",
              color: "#fff",
            }}
          >
            delete_outline
          </span>
        </div>
      )}
    </div>
  );
};
